import { z } from 'zod';
/**
 * Service codes of the Cash Deposits platform (cash-deposits.md section 11).
 * The API owns the catalog (names, parents, dependencies); the codes are shared
 * so the web can hide menu items and actions without guessing strings.
 */
export const DEPOSIT_SERVICE_CODES = [
    'DEPOSIT_LIST',
    'DEPOSIT_VIEW',
    'DEPOSIT_EXPORT',
    'DEPOSIT_DOCUMENT_VIEW',
    'DEPOSIT_REPRINT',
    'DEPOSIT_RESEND',
    'DEPOSIT_CREATE',
    'DEPOSIT_DELIVER',
    'DEPOSIT_RETURN',
    'DEPOSIT_UPDATE',
    'DEPOSIT_CANCEL',
    'DEPOSIT_REFERRAL_REVIEW',
    'REPORT_VIEW',
    'REPORT_EXPORT',
    'CURRENCY_LIST',
    'CURRENCY_VIEW',
    'CURRENCY_CREATE',
    'CURRENCY_UPDATE',
    'CURRENCY_CHANGE_STATUS',
    'SETTINGS_VIEW',
    'SETTINGS_UPDATE',
];
/** User and group services, identical to the Customers platform. */
export const ACCESS_SERVICE_CODES = [
    'USER_LIST',
    'USER_VIEW',
    'USER_CREATE',
    'USER_UPDATE',
    'USER_CHANGE_STATUS',
    'USER_RESET_PASSWORD',
    'USER_DELETE',
    'GROUP_LIST',
    'GROUP_VIEW',
    'GROUP_CREATE',
    'GROUP_UPDATE',
    'GROUP_CHANGE_STATUS',
    'GROUP_SERVICE_MANAGE',
    'GROUP_DELETE',
];
export const SERVICE_CODES = [...DEPOSIT_SERVICE_CODES, ...ACCESS_SERVICE_CODES];
export const serviceCodeSchema = z.enum(SERVICE_CODES);
/**
 * Built-in groups seeded on every installation (section 11, SRS SET-04).
 * The system group holds every service and cannot be deleted or emptied.
 */
export const SEEDED_GROUP_SERVICES = {
    SYSTEM_ADMIN: SERVICE_CODES,
    DEPOSITS_EMPLOYEE: [
        'DEPOSIT_LIST',
        'DEPOSIT_VIEW',
        'DEPOSIT_CREATE',
        'DEPOSIT_DELIVER',
        'DEPOSIT_RETURN',
        'DEPOSIT_REPRINT',
        'DEPOSIT_RESEND',
    ],
    SUPERVISOR: [
        'DEPOSIT_LIST',
        'DEPOSIT_VIEW',
        'DEPOSIT_CREATE',
        'DEPOSIT_DELIVER',
        'DEPOSIT_RETURN',
        'DEPOSIT_REPRINT',
        'DEPOSIT_RESEND',
        'DEPOSIT_UPDATE',
        'DEPOSIT_CANCEL',
        'DEPOSIT_REFERRAL_REVIEW',
        'DEPOSIT_DOCUMENT_VIEW',
    ],
    REPORTS_USER: ['DEPOSIT_LIST', 'DEPOSIT_VIEW', 'REPORT_VIEW'],
};
//# sourceMappingURL=contract.js.map